import { AppointmentConclusion } from '..';

export const hasConclusionServices = (conclusion?: AppointmentConclusion) => {
  return (
    conclusion?.requestedReferral?.services &&
    conclusion.requestedReferral.services.length > 0
  );
};
